import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

const Header = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };
  return (
    <header className="fixed top-0 left-0 right-0 py-4 z-10">
      <div className="max-w-4xl mx-auto px-4 flex justify-between items-center">
        <h1 className="text-4xl font-bold text-white">Weather App</h1>
        <nav className="hidden sm:flex items-center">
          <ul className={`flex space-x-4 ${isMenuOpen ? 'block' : 'visible'}`}>
            <li>
              <a className="text-white ">Home</a>
            </li>
            <li>
              <a className="text-white ">About</a>
            </li>
            <li>
              <a className="text-white ">Contact</a>
            </li>
          </ul>
        </nav>
        <button className="ml-4 text-white hover:text-gray-300 focus:outline-none sm:hidden"
            onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} size="lg" />
        </button>
      </div>
    </header>
  );
};

export default Header;
